export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-bitcoin-circle-87216fbb5707ee0b51af17c9756595e7.svg";